const utagLinkSortSearch = (query: string) => window.top.utag.link({ event_name: 'sort_search', search_term: query });

export default utagLinkSortSearch;
